import AdminIcon from "../../../assets/dashboardIcons/adminIcon.png";
import BillingIcon from "../../../assets/dashboardIcons/billingIcon.png";
import CRMEmployer from "../../../assets/dashboardIcons/crm-employer.png";
import CRMIcon from "../../../assets/dashboardIcons/crmIcon.png";
import EHRIcon from "../../../assets/dashboardIcons/ehrIcon.png";
import EmpIcon from "../../../assets/dashboardIcons/empManagerIcon.png";
import InventoryIcon from "../../../assets/dashboardIcons/inventoryIcon.png";
import ReportsIcon from "../../../assets/dashboardIcons/reportsLogo.png";
import {
  hasCustomPermission,
  hasPermission,
} from "../../../common/permissions";
import { permissions } from "../../../modules/Admin/Settings/Account/Users/constants/constants";

export const AVATAR_COLOR = { bg: "#dbeafe", color: "#1e40af" };

export const getStatusColor = (status: string) => {
  switch (status?.toUpperCase()) {
    case "ACTIVE":
      return { bg: "#e6f4ea", color: "#1e7e34" };
    case "INACTIVE":
      return { bg: "#fce8e6", color: "#c5221f" };
    case "PENDING":
      return { bg: "#fef7e0", color: "#f9a825" };
    default:
      return { bg: "#e8eaed", color: "#5f6368" };
  }
};

export const NavbarOptions = {
  CRM: {
    title: "CRM Retail",
    value: "CRM",
    icon: CRMIcon,
    hasPermission: false,
    permission: "Admin Dashboard", // Temporarily using ADMIN permissions as specified
    path: "/crm/home",
    basePath: "crm",
    options: [
      {
        name: "Home",
        path: "home",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Contacts",
        path: "contacts",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Patients",
        path: "patients",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Leads",
        path: "leads",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Tasks",
        path: "tasks",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Campaign",
        path: "campaign",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Call History",
        path: "call-history",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Library",
        path: "library",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Settings",
        path: "settings",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
    ],
  },
  CRM_RETAIL: {
    title: "CRM Retail",
    value: "CRM_Retail",
    icon: CRMIcon,
    hasPermission: false,
    permission: "CRM - Retail",
    path: "/crm/leads",
    basePath: "crm",
    options: [
      {
        name: "Leads",
        path: "leads",
        hasPermission: false,
        permission: "CRM - Retail",
      },
      {
        name: "Membership Plans",
        path: "membership-plans",
        hasPermission: false,
        permission: "Membership",
      },
      {
        name: "Notifications",
        path: "notifications",
        hasPermission: false,
        permission: "CRM - Retail",
      },
    ],
  },
  CRM_EMPLOYER: {
    title: "CRM Employer",
    value: "CRM_EMPLOYER",
    icon: CRMEmployer,
    hasPermission: false,
    permission: "CRM - Employer",
    path: "/crm/leads",
    basePath: "crm",
    options: [
      {
        name: "Leads",
        path: "leads",
        hasPermission: false,
        permission: "CRM - Employer",
      },
      {
        name: "Membership Plans",
        path: "membership-plans",
        hasPermission: false,
        permission: "Membership",
      },
      {
        name: "Notifications",
        path: "notifications",
        hasPermission: false,
        permission: "CRM - Employer",
      },
    ],
  },

  EHR: {
    title: "EHR",
    value: "EHR",
    basePath: "ehr",
    icon: EHRIcon,
    hasPermission: false,
    permission: "EHR Dashboard",
    path: "/ehr/dashboard",
    options: [
      {
        name: "Dashboard",
        path: "dashboard",
        hasPermission: false,
        permission: "EHR Dashboard",
      },
      {
        name: "Scheduling",
        path: "scheduling",
        hasPermission: false,
        permission: "EHR Scheduling",
      },
      {
        name: "Orders",
        path: "orders",
        hasPermission: false,
        permission: "EHR CPOE",
      },
      // {
      //   name: "Patients",
      //   path: "patients",
      //   hasPermission: false,
      //   permission: "EHR Patients",
      // },
      // {
      //   name: "Rx",
      //   path: "rx",
      //   hasPermission: false,
      //   permission: "EHR CPOE",
      // },
      // {
      //   name: "CPOE",
      //   path: "cpoe/lab-results",
      //   hasPermission: false,
      //   permission: "EHR CPOE",
      // },
      // {
      //   name: "Care Plans",
      //   path: "care-plans",
      //   hasPermission: false,
      //   permission: "EHR Care Plan",
      // },
      {
        name: "Tasks",
        path: "tasks",
        hasPermission: false,
        permission: "EHR Tasks",
      },
      {
        name: "Referral",
        path: "referral",
        hasPermission: false,
        permission: "EHR Referral",
      },
      // {
      //   name: "Education Material",
      //   path: "education-material",
      //   hasPermission: false,
      //   permission: "EHR Tasks",
      // },
      // {
      //   name: "Templates",
      //   path: "templates",
      //   hasPermission: false,
      //   permission: "EHR Referral",
      // },
      {
        name: "Fax",
        path: "fax",
        hasPermission: false,
        permission: "EHR Referral", //Need to change permission for fax
      },
      {
        name: "Patients",
        path: "cross-clinic-patients",
        hasPermission: false,
        permission: "EHR Patient Directory",
        permissionActions: ["view", "viewAll"],
      },
      {
        name: "Provider Directory",
        path: "provider-directory",
        hasPermission: false,
        permission: "Provider Directory",
        permissionActions: ["view", "viewAll"],
      },
      {
        name: "Settings",
        path: "settings",
        hasPermission: false,
        permission: "EHR_Settings_Custom",
        customPermissionCheck: true,
      },
    ],
  },
  ADMIN: {
    title: "Admin",
    value: "ADMIN",
    icon: AdminIcon,
    hasPermission: false,
    permission: "Admin Dashboard",
    path: "/admin/dashboard",
    basePath: "admin",
    options: [
      {
        name: "Dashboard",
        path: "dashboard",
        hasPermission: false,
        permission: "Admin Dashboard",
      },
      {
        name: "Form Builder",
        path: "form-builder",
        hasPermission: false,
        permission: "Admin Form Builder",
      },
      {
        name: "Membership",
        path: "membership",
        hasPermission: false,
        permission: "Admin Membership Plan",
      },
      {
        name: "Reports",
        path: "reports",
        hasPermission: false,
        permission: "Admin Reports",
      },
      {
        name: "Maps",
        path: "maps/global",
        hasPermission: false,
        permission: "Admin Maps",
      },
      {
        name: "Affiliate",
        path: "affiliate",
        hasPermission: false,
        permission: "Admin Affiliate",
      },
      {
        name: "Settings",
        path: "settings",
        hasPermission: false,
        permission: "Admin Settings",
      },
    ],
  },
  AFFILIATE_PORTAL: {
    bypassPermission: true,
    title: "Affiliate Portal",
    value: "AFFILIATE_PORTAL",
    hasPermission: false,
    path: "/affiliate-portal/affiliates",
    basePath: "affiliate-portal/affiliates",
    options: [
      {
        name: "Dashboard",
        path: "dashboard",
        bypassPermission: false,
        hasPermission: false,
        permission: "Affiliate Portal Dashboard",
      },
      {
        name: "Patients",
        path: "patients",
        bypassPermission: false,
        hasPermission: false,
        permission: "Affiliate Portal Patients",
      },
      {
        name: "Invoices",
        path: "payments",
        bypassPermission: false,
        hasPermission: false,
        permission: "Affiliate Portal Invoices",
      },
      {
        name: "Notifications",
        path: "notifications",
        bypassPermission: false,
        hasPermission: false,
        permission: "Affiliate Portal Notifications",
      },
      {
        name: "Settings",
        path: "settings",
        bypassPermission: false,
        hasPermission: false,
        permission: "Affiliate Portal Settings",
      },
    ],
  },
  BROKER_PORTAL: {
    title: "Agents",
    value: "BROKER_PORTAL",
    icon: EmpIcon,
    hasPermission: true,
    path: "/broker-portal/dashboard",
    basePath: "broker-portal",
    options: [
      {
        name: "Dashboard",
        path: "dashboard",
      },
      {
        name: "Employers",
        path: "employers",
      },
      {
        name: "Commission Invoices",
        path: "commission-invoices",
      },
      {
        name: "Settings",
        path: "settings",
      },
    ],
  },
  INVENTORY: {
    title: "Inventory",
    value: "INVENTORY",
    icon: InventoryIcon,
    hasPermission: true,
    permission: "Inventory",
    path: "/inventory",
    basePath: "inventory",
    options: [
      {
        name: "Dashboard",
        path: "dashboard",
        hasPermission: false,
        permission: "Inventory Dashboard",
      },
      {
        name: "Formulary",
        path: "formulary",
        hasPermission: false,
        permission: "Inventory Formulary",
      },
      {
        name: "Shipments",
        path: "shipments",
        hasPermission: false,
        permission: "Inventory Shipment",
      },
      {
        name: "Inventory",
        path: "inventory",
        hasPermission: false,
        permission: "Inventory Inventory",
      },
      {
        name: "Orders",
        path: "orders",
        hasPermission: false,
        permission: "Inventory Orders",
      },
      {
        name: "Reports",
        path: "reports",
        hasPermission: false,
        permission: "Inventory Reports",
      },
      {
        name: "Settings",
        path: "settings",
        hasPermission: false,
        permission: "Inventory Settings",
      },
    ],
  },
  BILLING: {
    title: "Billing",
    value: "BILLING",
    icon: BillingIcon,
    hasPermission: false,
    permission: "Billing",
    path: "/billing/all-employees",
    basePath: "billing",
    options: [
      {
        name: "All Patients",
        path: "all-employees",
        hasPermission: false,
        permission: "Billing Patients",
      },
      {
        name: "Employer",
        path: "employers",
        hasPermission: false,
        permission: "Billing Employers",
      },
      {
        name: "Settings",
        path: "settings",
        hasPermission: false,
        permission: "Billing Basic Details",
      },
    ],
  },
  EMPLOYER_MANAGEMENT: {
    title: "Employer Management",
    value: "EMPLOYER_MANAGEMENT",
    icon: EmpIcon,
    hasPermission: false,
    permission: "Employer Management",
    path: "/employer/employers",
    basePath: "employer",
    options: [
      {
        name: "Employers",
        path: "employers",
        hasPermission: false,
        permission: "EM Employers",
      },
      {
        name: "All Employees",
        path: "all-employees",
        hasPermission: false,
        permission: "EM All employees",
        permissionActions: ["view", "viewAll"],
      },
      {
        name: "Coverage Plans",
        path: "coverage-plans",
        hasPermission: false,
        permission: "EM Coverage Plan",
      },
      {
        name: "Tickets",
        path: "tickets",
        hasPermission: true,
        permission: "EM Dashboard",
      },
      {
        name: "Broker",
        path: "broker",
        hasPermission: false,
        permission: "EM Brokers",
      },
      {
        name: "Settings",
        path: "settings",
        hasPermission: false,
        permission: "EM Basic Details",
      },
    ],
  },
  EMPLOYER_PORTAL: {
    title: "EMP",
    value: "EMPLOYER_PORTAL",
    icon: EmpIcon,
    hasPermission: true,
    path: "/employer-portal/employers/dashboard",
    basePath: "employer-portal/employers",
    options: [
      {
        name: "Dashboard",
        path: "dashboard",
        hasPermission: false,
        permission: "EMP Dashboard",
      },
      {
        name: "All Employees",
        path: "all-employees",
        hasPermission: false,
        permission: "EMP All employees",
      },
      {
        name: "Invoices",
        path: "invoices",
        hasPermission: false,
        permission: "EMP Invoices",
      },
      {
        name: "Payment Options",
        path: "payment-option",
        hasPermission: false,
        permission: "EMP Payment Option",
      },
      {
        name: "Audit Log",
        path: "notifications",
        hasPermission: false,
        permission: "EMP Notifications",
      },
      {
        name: "Memberships",
        path: "memberships",
        hasPermission: false,
        permission: "EMP Memberships",
      },
      {
        name: "Tickets",
        path: "tickets",
        hasPermission: false,
        permission: "EMP Notes",
      },
      {
        name: "Employee Uploads",
        path: "employee-uploads",
        hasPermission: false,
        permission: "EMP Employee Uploads",
      },
      {
        name: "Coverage Plans",
        path: "coverage-plans",
        hasPermission: false,
        permission: "EMP Coverage Plan",
      },
      {
        name: "Settings",
        path: "settings",
        hasPermission: false,
        permission: "EMP Basic Details",
      },
      {
        name: "Terminations",
        path: "terminations",
        hasPermission: false,
        permission: "Terminations",
      },
    ],
  },
  REPORTS: {
    title: "Reports",
    value: "REPORTS",
    icon: ReportsIcon,
    hasPermission: false,
    permission: "Clinic/Provider Activity",
    path: "/reports/clinical-reports/appointment-report",
    basePath: "reports",
    options: [
      {
        name: "Clinical Reports",
        path: "clinical-reports/appointment-report",
        hasPermission: true,
        permission: "Admin Dashboard",
      },
      {
        name: "Billing Reports",
        path: "billing-reports/churn-report",
        hasPermission: true,
        permission: "Admin Dashboard",
      },
    ],
  },
};

export const hasAnyPermissionForModule = (
  moduleOptions: any[],
  userPermissions: any,
  user?: any,
): boolean => {
  if (!moduleOptions || moduleOptions.length === 0) {
    return true;
  }

  const permissionedOptions = moduleOptions.filter((option) => {
    return !option.bypassPermission && option.permission;
  });

  if (permissionedOptions.length === 0) {
    return true;
  }

  const allPermissionsFalse = permissionedOptions.every((option) => {
    if (!option.permission) return false;

    if (option.customPermissionCheck) {
      const customPermissionResult = hasCustomPermission(
        userPermissions,
        option.permission,
        user,
      );

      return !customPermissionResult;
    }

    return !hasPermission(userPermissions, option.permission, "view");
  });

  if (allPermissionsFalse) {
    return false;
  }

  return moduleOptions.some((option) => {
    if (option.bypassPermission === true) return true;

    if (!option.permission) return true;

    if (option.customPermissionCheck) {
      const customPermissionResult = hasCustomPermission(
        userPermissions,
        option.permission,
        user,
      );

      return customPermissionResult;
    }

    return hasPermission(userPermissions, option.permission, "view");
  });
};

export const getFilteredNavbarOptions = (
  navbarOptions: any,
  userPermissions: any,
  user?: any,
): any => {
  const filteredOptions: any = {};

  Object.entries(navbarOptions).forEach(([key, module]: [string, any]) => {
    // Hide INVENTORY module for affiliate users
    if (key === "INVENTORY" && user?.roleType === "AFFILIATE") {
      return;
    }

    // Hide CRM Retail (legacy `CRM` and active `CRM_RETAIL`) from the master board and navigation
    if (key === "CRM" || key === "CRM_RETAIL") {
      return;
    }

    if (module.hasPermission === true) {
      filteredOptions[key] = module;
      return;
    }

    const hasAnyPermission = hasAnyPermissionForModule(
      module.options,
      userPermissions,
      user,
    );

    if (hasAnyPermission) {
      filteredOptions[key] = module;
    } else {
      // console.log(
      //   `Module "${key}" (${module.title}) filtered out - no permissions`,
      // );
    }
  });

  return filteredOptions;
};

export const getFilteredModuleOptions = (
  moduleOptions: any[],
  userPermissions: any,
  user?: any,
): any[] => {
  if (!moduleOptions || moduleOptions.length === 0) {
    return [];
  }

  return moduleOptions.filter((option) => {
    if (user?.roleType === "CLINIC_USER" && option.path === "settings") {
      return false;
    }

    if (user?.roleType === "AGENT") {
      const allowedAgentOptions = ["employers"];
      if (!allowedAgentOptions.includes(option.path)) {
        return false;
      }
    }
    // if (
    //   user?.roleType === "AFFILIATE" &&

    //   ["payments", "notifications", "settings"].includes(option.path)
    // ) {
    //   console.log("returning false")
    //   return false;
    // }
    if (option.bypassPermission === true) return true;

    if (!option.permission) return true;

    if (option.customPermissionCheck) {
      const customPermissionResult = hasCustomPermission(
        userPermissions,
        option.permission,
        user,
      );

      return customPermissionResult;
    }

    // Options default to requiring "viewAll"; an option can widen this with
    // permissionActions (e.g. ["view", "viewAll"]) so any of them grants
    // visibility.
    const permissionActions: string[] = option.permissionActions || ["viewAll"];
    const hasViewPermission = permissionActions.some((action) =>
      hasPermission(userPermissions, option.permission, action as any),
    );
    return hasViewPermission;
  });
};
